import { config, gameState } from '../index';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    config.audio.bgAudio = this.sound.add('bgMusic');

    if (gameState.level == 1) {
      this.startloads();

      this.load.start();
    }

    this.run = true;
    //this.cameras.main.zoom = 0.5;

    if (gameState.level == 1) {
      this.bg = this.add.image(640, 360, 'Background');
      this.box = this.add.image(655, 335, 'box').setOrigin(0.5, 0.29).setScale(0.25);
    } else if (gameState.level == 2) {
      this.bg = this.add.image(640, 360, 'Background2');

      this.box2 = this.add.image(433, 275, 'box-2').setScale(0.1);
    } else if (gameState.level == 3) {
      this.bg = this.add.image(640, 360, 'Background3');

      this.box3 = this.add.image(700, 220, 'box-3').setScale(0.09);
    } else if (gameState.level == 4) {
      this.bg = this.add.image(638, 28, 'Background4').setOrigin(0.5, 0.04);
      this.door = this.add
        .image(638, 28, 'door')
        .setOrigin(0.47, 0.21)
        .setScale(0.22, 0.22)
        .setAlpha(0.1);
      this.rock = this.add
        .image(638, 28, 'rock')
        .setOrigin(0.47, 0.21)
        .setScale(0.22, 0.22);

      //this.door = this.add.image(665,25+36,'door').setOrigin(0.5,-0.41).setScale(0.275,0.275).setAlpha(0.1)
    }

    //this.web = this.add.image(545,405,'web').setScale(0.3).setOrigin(0,0)

    this.playButton = this.add
      .image(529, 580, 'play_button')
      .setInteractive({ cursor: 'pointer' })
      .setOrigin(0, 0);

    this.playButton.on(
      'pointerover',
      function (pointer) {
        this.playButton.setTexture('play_button_on');
        //this.scene.pause("GameLoadScene");
      },
      this,
    );

    this.playButton.on(
      'pointerout',
      function (pointer) {
        this.playButton.setTexture('play_button');
        //this.scene.resume("GameLoadScene");
      },
      this,
    );

    this.playButton.on(
      'pointerdown',
      function (pointer) {
        enablePointerEvents();
        config.audio.bgAudio.setLoop(true).setVolume(0.1).play();

        // this.gamename.setScale(0);
        this.playButton.setScale(0);

        this.time.delayedCall(
          250,
          () => {
            const cam = this.cameras.main;
            cam.pan(640, 350, 3000, 'Power2');
            (cam.zoomTo(4, 3000), 'Power2');
          },
          [],
          this,
        );

        this.time.delayedCall(
          3500,
          () => {
            this.scene.start('GameScene');

            //this.scene.start("FinalScene");

            //this.scene.launch("HintScene");

            this.scene.stop('StartScene');

            //this.scene.start("EndScene");
          },
          [],
          this,
        );
      },
      this,
    );
  }

  startloads() {
    this.load.image('box-2', 'assets/StartSceneAssets/box-2.png');
    this.load.image('box-3', 'assets/StartSceneAssets/box-3.png');

    this.load.image('Background4', 'assets/StartSceneAssets/Background4.png');
    this.load.image('rock', 'assets/StartSceneAssets/rock.png');
    this.load.image('door', 'assets/StartSceneAssets/door.png');
    this.load.image('Background2', 'assets/StartSceneAssets/Background2.png');
    this.load.image('Background3', 'assets/StartSceneAssets/Background3.png');

    this.load.plugin(
      'rexflashplugin',
      'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexflashplugin.min.js',
      true,
    );
    //
    this.load.image('bg', 'assets/GameSceneAssets/bg.png');

    this.load.image('bg2', 'assets/GameSceneAssets/bg2.png');

    this.load.image('cursor', 'assets/GameSceneAssets/cursor.png');

    this.load.image('input1', 'assets/GameSceneAssets/Input-1.png');
    this.load.image('input2', 'assets/GameSceneAssets/Input-2.png');
    this.load.image('input3', 'assets/GameSceneAssets/input-3.png');
    this.load.image('input4', 'assets/GameSceneAssets/input-4.png');
    this.load.image('input5', 'assets/GameSceneAssets/input-5.png');

    this.load.image('checkbutton', 'assets/GameSceneAssets/check.png');

    this.load.image('checkbutton_on', 'assets/GameSceneAssets/check_on.png');

    this.load.image('donebutton', 'assets/EndSceneAssets/done.png');

    this.load.image('donebutton_on', 'assets/EndSceneAssets/done_on.png');

    this.load.atlas(
      'confettiAnim',
      'assets/GameSceneAssets/confettiAnim.png',
      'assets/GameSceneAssets/confettiAnim.json',
    );
    this.load.atlas(
      'KeyNewAnim',
      'assets/GameSceneAssets/KeyNewAnim-0.png',
      'assets/GameSceneAssets/KeyNewAnim.json',
    );

    this.load.multiatlas(
      'chest2Anim',
      'assets/EndSceneAssets/ChestTwoAnim/ChestTwoAnim.json',
      'assets/EndSceneAssets/ChestTwoAnim',
    );

    //
    this.load.atlas(
      'Gem1Anim',
      'assets/EndSceneAssets/Gem1Anim.png',
      'assets/EndSceneAssets/Gem1Anim.json',
    );

    this.load.atlas(
      'Gem2Anim',
      'assets/EndSceneAssets/Gem2Anim.png',
      'assets/EndSceneAssets/Gem2Anim.json',
    );
    this.load.atlas(
      'Gem3Anim',
      'assets/EndSceneAssets/Gem3Anim.png',
      'assets/EndSceneAssets/Gem3Anim.json',
    );
    this.load.image('ebg', 'assets/EndSceneAssets/ebg.png');
    // this.load.image("ebg2", "assets/EndSceneAssets/ebg2.png");
    // this.load.image("ebg3", "assets/EndSceneAssets/ebg3.png");

    this.load.image('slot', 'assets/EndSceneAssets/slot.png');
    this.load.image('slot1', 'assets/EndSceneAssets/slot1.png');
    this.load.image('slot2', 'assets/EndSceneAssets/slot2.png');
    this.load.image('slot3', 'assets/EndSceneAssets/slot3.png');

    this.load.image('fbg', 'assets/EndSceneAssets/fbg.png');

    this.load.image('gem', 'assets/EndSceneAssets/gem.png');

    this.load.image('gemon', 'assets/EndSceneAssets/gemon.png');

    this.load.image('gemon2', 'assets/EndSceneAssets/gem2on.png');

    this.load.image('gemon3', 'assets/EndSceneAssets/gem3on.png');
    this.load.image('gem2', 'assets/EndSceneAssets/gem2.png');
    this.load.image('gem3', 'assets/EndSceneAssets/gem3.png');
  }

  update() {
    if (this.run && gameState.level > 1) {
      this.playButton.setScale(0);

      this.run = false;

      if (gameState.level == 2) {
        this.slot = this.add.image(29, 24, 'slot1').setOrigin(0, 0);
      } else if (gameState.level == 3) {
        this.slot = this.add.image(29, 24, 'slot2').setOrigin(0, 0);
      } else {
        this.slot = this.add.image(29, 24, 'slot3').setOrigin(0, 0);
      }

      this.time.delayedCall(
        1500,
        () => {
          const cam = this.cameras.main;

          if (gameState.level == 2) {
            cam.pan(375, 250, 3000, 'Power2');
            (cam.zoomTo(4, 3000), 'Power2');
            this.tweens.add({
              targets: this.box2,
              alpha: 1,
              ease: 'Power2', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
              duration: 3000,
              repeat: 0, // -1: infinity
              yoyo: false,
            });
          } else if (gameState.level == 3) {
            cam.pan(740, 200, 3000, 'Power2');
            (cam.zoomTo(6, 3000), 'Power2');
            this.tweens.add({
              targets: this.box3,
              alpha: 1,
              ease: 'Power2', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
              duration: 3000,
              repeat: 0, // -1: infinity
              yoyo: false,
            });
          } else {
            this.tweens.add({
              targets: [this.bg],
              scaleY: 4,
              scaleX: 4,
              ease: 'Power2', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
              duration: 4000,
              repeat: 0, // -1: infinity
              yoyo: false,
            });

            this.tweens.add({
              targets: [this.door],
              scaleY: 0.88,
              scaleX: 0.88,
              alpha: 1,
              ease: 'Power2', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
              duration: 4000,
              repeat: 0, // -1: infinity
              yoyo: false,
            });

            this.tweens.add({
              targets: [this.rock],
              scaleY: 0.88,
              scaleX: 0.88,
              alpha: 0,
              ease: 'Power2', // 'Cubic', 'Elastic', 'Bounce', 'Back' ,'Sine.easeOut',
              duration: 4000,
              repeat: 0, // -1: infinity
              yoyo: false,
            });
          }
          this.time.delayedCall(
            4000,
            () => {
              enablePointerEvents();

              if (gameState.level < 4) {
                this.scene.start('GameScene');

                //this.scene.launch("HintScene");

                //this.scene.start("EndScene");
              } else {
                this.scene.start('FinalScene');
              }

              this.scene.stop('StartScene');
            },
            [],
            this,
          );
        },
        [],
        this,
      );
    }
  }
}
